"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnAuUsd = exports.EnAuAud = void 0;
class EnAuAud {
    constructor() {
        this.locale = "en-au";
        this.dateFormat = {
            short: "d/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "AUD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnAuAud = EnAuAud;
class EnAuUsd {
    constructor() {
        this.locale = "en-au";
        this.dateFormat = {
            short: "d/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "US$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnAuUsd = EnAuUsd;
